import { useRef,useState } from "react";

import { Button } from "components/ui/Button";

import styles from "./UploadResultsModal.module.css";

const UploadResultsModal = ({ isOpen, onClose, onSave, isUploading }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  if (!isOpen) return null;

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files).filter(
      (file) => file.name.endsWith(".xml") || file.type === "text/xml"
    );

    if (files.length > 0) {
      setSelectedFiles(files);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setSelectedFiles(files);
    }

    e.target.value = "";
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  const handleSave = () => {
    if (selectedFiles.length > 0) {
      onSave(selectedFiles);
      setSelectedFiles([]);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleCancel = () => {
    setSelectedFiles([]);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    onClose();
  };

  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleCancel}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>Add results manually</h2>
          <button className={styles.closeButton} onClick={handleCancel}>
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <div
            className={`${styles.dropZone} ${
              isDragging ? styles.dragging : ""
            }`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <p className={styles.dropText}>
              Drop your files here or{" "}
              <span className={styles.browseLink} onClick={handleBrowseClick}>
                Browse
              </span>
            </p>
            <p className={styles.maxSize}>Maximum size: 50MB</p>
          </div>

          <input
            ref={fileInputRef}
            type="file"
            accept=".xml"
            multiple
            onChange={handleFileSelect}
            style={{ display: "none" }}
          />

          {selectedFiles.length > 0 && (
            <div className={styles.fileList}>
              <h4>Selected files:</h4>
              {selectedFiles.map((file, index) => (
                <div key={index} className={styles.fileItem}>
                  <span className={styles.fileName}>{file.name}</span>
                  <span className={styles.fileSize}>
                    ({(file.size / 1024).toFixed(2)} KB)
                  </span>
                  <button
                    className={styles.removeButton}
                    onClick={() => removeFile(index)}
                    disabled={isUploading}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={styles.modalFooter}>
          <Button
            variant="outline"
            size="large"
            onClick={handleCancel}
            disabled={isUploading}
            style={{ flex: 1 }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="large"
            onClick={handleSave}
            disabled={selectedFiles.length === 0 || isUploading}
            style={{ flex: 1 }}
          >
            {isUploading ? "Uploading..." : "Save"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { UploadResultsModal };